import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import axios from 'axios'
import api from "../../../constants/api"
import logo from '../../../images/logo-new.svg'
import qr from '../../../images/qr.png'

const EnquiryPdfView = () => {
    const params = useParams();
    const [enquiry, setEnquiry] = useState<any>({ cart_items: [] })

    const getEnquiry = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL + api.inquiryDetail
            const headers = { 'Content-Type': 'application/json' }
            const response = await axios.post(apiUrl, { id: params.id }, { headers })
            setEnquiry(response.data.data.enquiry);
        } catch (error) { }
    }

    useEffect(() => {
        getEnquiry()
    }, [])

    // Calculate totals
    const parseGST = (gstString: any) => {
        if (!gstString) return 0;
        const match = gstString.toString().match(/(\d+(\.\d+)?)/);
        return match ? parseFloat(match[1]) : 0;
    };

    const untaxedAmount = enquiry.cart_items.reduce(
        (acc: number, item: any) => acc + item.price * (item.quantity || 1),
        0
    );

    const discountAmount = enquiry.cart_items.reduce((acc: number, item: any) => {
        const qty = item.quantity || 1;
        const itemSubtotal = item.price * qty;
        const itemDiscount = (itemSubtotal * (item.discount || 0)) / 100;
        return acc + itemDiscount;
    }, 0);

    const totalAfterDiscount = untaxedAmount - discountAmount;

    // product GST calculation
    const productGST = enquiry.cart_items.reduce((acc: number, item: any) => {
        const qty = item.quantity || 1;
        const itemSubtotal = item.price * qty;
        const itemDiscount = (itemSubtotal * (item.discount || 0)) / 100;
        const taxableAmount = itemSubtotal - itemDiscount;

        const gstPercentage = parseGST(item.GST);
        return acc + (taxableAmount * gstPercentage) / 100;
    }, 0);

    // GST on delivery charges (always 18%)
    const deliveryCharges = enquiry.delivery_charges || 0;
    const deliveryGST = deliveryCharges * 0.18;

    // 🔥 Combine both GST values into `taxedAmount`
    const taxedAmount = productGST + deliveryGST;

    const total = totalAfterDiscount + taxedAmount + deliveryCharges;
    const roundedTotal = Math.round(total);
    const roundOffValue = (roundedTotal - total).toFixed(2);




    return (
        <div className="bg-white py-4 sm:py-6 md:py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                    <div className="flex justify-center sm:justify-start">
                        <img src={logo} alt="logo" className="w-32 sm:w-40 md:w-64" />
                    </div>
                    <div className="text-left sm:text-right mt-4 sm:mt-0 relative">
                        <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-black mb-1 relative z-10">
                            Vijaydeep Mould Accessories Pvt.Ltd
                        </h1>

                        <p className="text-sm sm:text-base font-normal text-black leading-6 sm:leading-7 relative z-10">
                            # 205, 2nd floor, T-Square Building, Chandivali Junction <br />
                            Saki Vihar Road, Saki Naka, Andheri-East <br />
                            Mumbai Maharashtra MH <br />
                            India 400072 GSTIN: 27AACCV4475F1Z6 <br />
                            Phone: 02261077900 E-mail: sales@vijaydeep.in <br />
                            <Link to="http://www.vijaydeep.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                www.vijaydeep.in
                            </Link>
                        </p>
                        {/* <div className='absolute w-[700px] h-[300px] bg-[#eeecef] -top-[60px] -right-[150px] hidden sm:block'
                            style={{
                                borderRadius: '0px 0px 0px 800px'
                            }}
                        >

                        </div> */}

                    </div>
                </div>

                {/* Customer Info */}
                <div className="mt-4 md:mt-0">
                    <h2 className="text-xl sm:text-4xl font-normal text-[#5e4666]">
                        Quotation # {enquiry.odoo_display_name || enquiry.order_number || "-"}
                    </h2>
                    {/* <p className="text-base sm:text-lg md:text-xl font-medium text-black mt-2">
                        Quotation Date {enquiry.createdAt ? new Date(enquiry.createdAt.$date || enquiry.createdAt).toLocaleDateString() : "-"}
                    </p> */}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mt-7">
                    <div className="text-left">
                        <h3 className="text-lg sm:text-xl font-medium text-black mb-1">
                            Invoice Address:
                        </h3>
                        <p className="text-sm sm:text-base md:text-lg font-normal text-black leading-6 sm:leading-7">
                            {enquiry.name} <br />
                            {enquiry.company} <br />
                            {enquiry.address} <br />
                            {enquiry.additional_address} <br />
                            {enquiry.city} <br />
                            {enquiry.state} {enquiry.country} {enquiry.pincode} <br />
                            <b>Kind Attention:</b> {enquiry.name} <br />
                            <b>Mo:</b> {enquiry.mobile} <br />
                            <b>Email:</b> {enquiry.email} {enquiry.gstin && <><br /><b>GSTIN:</b> {enquiry.gstin}</>} <br />
                            {enquiry.type === "morehelp" && (
                                <>
                                    <b>Help Message:</b> {enquiry.message} <br />
                                </>
                            )}
                        </p>
                    </div>
                    <div className="text-left sm:text-right">
                        <h4 className="text-lg sm:text-xl font-medium text-black mb-1">
                            Shipping Address:
                        </h4>
                        <p className="text-sm sm:text-base md:text-lg font-normal text-black leading-6 sm:leading-7">
                            {enquiry.name} <br />
                            {enquiry.delivery_company} <br />
                            {enquiry.delivery_address} <br />
                            {enquiry.deliveryAdditionalAddress} <br />
                            {enquiry.delivery_city}  <br />
                            {enquiry.delivery_state} {enquiry.delivery_country} {enquiry.delivery_pincode} <br />
                        </p>
                        {/* <p className="text-sm sm:text-base md:text-lg font-medium text-black mt-3">
                            Payment Terms: {enquiry.payment_terms || "-"}
                        </p> */}
                    </div>
                </div>
                <div className='border border-black bg-[#eeecef] p-3 rounded-xl mt-7'>
                    <div className='grid grid-cols-1 sm:grid-cols-5 gap-2'>
                        <div>
                            <p className='text-sm font-medium text-black mb-1'>Order date</p>
                            <p className='text-sm font-medium text-black'>{enquiry.createdAt ? new Date(enquiry.createdAt.$date || enquiry.createdAt).toLocaleDateString() : "-"}</p>
                        </div>
                        <div>
                            <p className='text-sm font-medium text-black mb-1'>Incoterm</p>
                            <p className='text-sm font-medium text-black'></p>
                        </div>
                        <div>
                            <p className='text-sm font-medium text-black mb-1'>Salesperson</p>
                            <p className='text-sm font-medium text-black'></p>
                        </div>
                        <div>
                            <p className='text-sm font-medium text-black mb-1'>Payment Terms</p>
                            <p className='text-sm font-medium text-black'>{enquiry.payment_terms || "-"}</p>
                        </div>
                        <div>
                            <p className='text-sm font-medium text-black mb-1'>Ticket No</p>
                            <p className='text-sm font-medium text-black'></p>
                        </div>
                    </div>
                </div>
                {/* Table */}
                <div className="mt-4 sm:mt-6 overflow-x-auto">
                    <div className="rounded-t-3xl rounded-l-3xl min-w-[640px]">
                        <table className="w-full border-collapse">
                            <thead className="bg-[#5e4666] text-white rounded-t-3xl">
                                <tr>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[60px] sm:w-[80px]">SR. NO.</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 min-w-[150px]">Description</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[100px]">HSN/SAC</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[100px]">LEAD TIME (Days)</th>
                                    {/* <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[80px]">Project No</th> */}
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[80px]">QTY (UNITS)</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[100px]">UNIT PRICE</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[80px]">DISC.%</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[100px]">TAXES</th>
                                    <th className="border border-gray-300 text-center font-medium text-sm sm:text-base md:text-lg p-2 sm:p-3 md:p-4 w-[100px]">AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {enquiry.cart_items && enquiry.cart_items.length > 0 ? enquiry.cart_items.map((item: any, idx: number) => {
                                    const gstPercent = parseGST(item.GST);
                                    const itemDiscount = (item.price * item.quantity * (item.discount || 0)) / 100;
                                    const itemTaxable = item.price * item.quantity - itemDiscount;
                                    const itemGSTValue = (itemTaxable * gstPercent) / 100;
                                    const itemAmount = itemTaxable + itemGSTValue; // 🔥 final per item

                                    return (
                                        <tr key={idx}>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{idx + 1}</td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-left font-medium text-black text-sm sm:text-base">
                                                {item.name}
                                                {item.project_no ? ` (${item.project_no})` : ""}
                                            </td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{item.HSN_code}</td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{item.quantity_on_hand >= item.quantity ? 1 : item.no_lead_day}</td>
                                            {/* <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{item.project_no}</td> */}
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{item.quantity}</td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{item.price.toFixed(2)}</td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">{item.discount || 0}</td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">
                                                {(() => {
                                                    if (!item.GST) return "0%";
                                                    const match = String(item.GST).match(/(\d+(\.\d+)?)%/);
                                                    return match ? `${match[1]}%` : "0%";
                                                })()}
                                            </td>
                                            <td className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black bg-[#f3f4f6] text-sm sm:text-base">₹ {itemAmount.toFixed(2)}</td>
                                        </tr>
                                    )
                                }) : (
                                    <tr>
                                        <td colSpan={9} className="border border-gray-300 p-2 sm:p-3 md:p-4 text-center font-medium text-black text-sm sm:text-base">No items found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Totals */}
                <div className='grid grid-cols-1'>
                    <div className="border-b-2 border-x-2 border-gary-300 rounded-b-[24px] ml-auto">
                        <div className="flex border-b-2 border-gray-300">
                            <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                <p className="text-sm sm:text-base font-medium text-black">Untaxed Amount</p>
                            </div>
                            <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                <p className="text-sm sm:text-base font-medium text-black">₹ {untaxedAmount.toFixed(2)}</p>
                            </div>
                        </div>
                        {discountAmount > 0 && (
                            <div className="flex border-b-2 border-gray-300 bg-[#f3f4f6]">
                                <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                    <p className="text-sm sm:text-base font-medium text-black">Discount</p>
                                </div>
                                <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                    <p className="text-sm sm:text-base font-medium text-black">
                                        ₹ {discountAmount.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        )}
                        <div className="flex border-b-2 border-gray-300">
                            <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                <p className="text-sm sm:text-base font-medium text-black">Freight Charge</p>
                            </div>
                            <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                <p className="text-sm sm:text-base font-medium text-black">₹ {enquiry.delivery_charges ? enquiry.delivery_charges.toFixed(2) : "0.00"}</p>
                            </div>
                        </div>
                        {(() => {
                            const targetState = enquiry.delivery_state || enquiry.state || '';
                            const isMaharashtra = targetState.toLowerCase().includes('maharashtra') || 
                                                (enquiry.gstin && enquiry.gstin.toString().startsWith('27'));
                            
                            if (isMaharashtra) {
                                const halfTax = (taxedAmount / 2).toFixed(2);
                                return (
                                    <>
                                        <div className="flex border-b-2 border-gray-300">
                                            <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                                <p className="text-sm sm:text-base font-medium text-black">CGST</p>
                                            </div>
                                            <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                                <p className="text-sm sm:text-base font-medium text-black">₹ {halfTax}</p>
                                            </div>
                                        </div>
                                        <div className="flex border-b-2 border-gray-300">
                                            <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                                <p className="text-sm sm:text-base font-medium text-black">SGST</p>
                                            </div>
                                            <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                                <p className="text-sm sm:text-base font-medium text-black">₹ {halfTax}</p>
                                            </div>
                                        </div>
                                    </>
                                );
                            } else {
                                return (
                                    <div className="flex border-b-2 border-gray-300">
                                        <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                            <p className="text-sm sm:text-base font-medium text-black">IGST</p>
                                        </div>
                                        <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                            <p className="text-sm sm:text-base font-medium text-black">₹ {taxedAmount.toFixed(2)}</p>
                                        </div>
                                    </div>
                                );
                            }
                        })()}
                        <div className="flex border-b-2 border-gray-300 bg-[#f3f4f6]">
                            <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                <p className="text-sm sm:text-base font-medium text-black">Round Off. Amount</p>
                            </div>
                            <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                <p className="text-sm sm:text-base font-medium text-black">
                                    ₹ {roundOffValue}
                                </p>
                            </div>
                        </div>
                        <div className="flex bg-[#5e4666] rounded-b-3xl">
                            <div className="flex-none w-3/5 sm:w-[300px] p-2 sm:p-3 md:p-4 border-r-2 border-gray-300">
                                <p className="text-sm sm:text-base font-semibold text-white">Total Amount</p>
                            </div>
                            <div className="flex-none w-2/5 sm:w-[200px] p-2 sm:p-3 md:p-4 text-end">
                                <p className="text-sm sm:text-base font-semibold text-white">₹ {roundedTotal.toFixed(2)}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bank Details and QR */}
                <div className="my-4 sm:my-6">
                    <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-[#5e4666] text-center sm:text-left">
                        Please deposit the payment in the below mentioned bank account and intimate us immediately.
                    </h2>
                    <div className="flex flex-col sm:flex-row mt-4 gap-4 sm:gap-8">
                        <div className="flex-1 border-2 border-gray-500 rounded-3xl">
                            <div className="flex border-b-2 border-gray-300">
                                <div className="flex-none w-2/5 sm:w-[300px] p-2 sm:p-3 border-r-2 border-gray-300">
                                    <p className="text-sm sm:text-lg md:text-xl font-semibold text-black">Account Name:</p>
                                </div>
                                <div className="flex-1 p-2 sm:p-3">
                                    <p className="text-sm sm:text-lg md:text-xl font-medium text-black break-words">
                                        Vijaydeep Mould Accessories Pvt.Ltd
                                    </p>
                                </div>
                            </div>
                            <div className="flex border-b-2 border-gray-300">
                                <div className="flex-none w-2/5 sm:w-[300px] p-2 sm:p-3 border-r-2 border-gray-300">
                                    <p className="text-sm sm:text-lg md:text-xl font-semibold text-black">Bank Name:</p>
                                </div>
                                <div className="flex-1 p-2 sm:p-3">
                                    <p className="text-sm sm:text-lg md:text-xl font-medium text-black">HDFC Bank</p>
                                </div>
                            </div>
                            <div className="flex border-b-2 border-gray-300">
                                <div className="flex-none w-2/5 sm:w-[300px] p-2 sm:p-3 border-r-2 border-gray-300">
                                    <p className="text-sm sm:text-lg md:text-xl font-semibold text-black">Branch A/C No.:</p>
                                </div>
                                <div className="flex-1 p-2 sm:p-3">
                                    <p className="text-sm sm:text-lg md:text-xl font-medium text-black">0085421786202</p>
                                </div>
                            </div>
                            <div className="flex border-b-2 border-gray-300">
                                <div className="flex-none w-2/5 sm:w-[300px] p-2 sm:p-3 border-r-2 border-gray-300">
                                    <p className="text-sm sm:text-lg md:text-xl font-semibold text-black">Branch Name:</p>
                                </div>
                                <div className="flex-1 p-2 sm:p-3">
                                    <p className="text-sm sm:text-lg md:text-xl font-medium text-black">VISHAL HALL, ANDHERI (EAST)</p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex-none w-2/5 sm:w-[300px] p-2 sm:p-3 border-r-2 border-gray-300">
                                    <p className="text-sm sm:text-lg md:text-xl font-semibold text-black">IFSC Code:</p>
                                </div>
                                <div className="flex-1 p-2 sm:p-3">
                                    <p className="text-sm sm:text-lg md:text-xl font-medium text-black">HDFC0000086</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex-none flex flex-col items-center">
                            <div className="bg-[#f3f6fd] px-6 sm:px-8 py-3">
                                <img src={qr} alt="qr" className="w-24 sm:w-32 md:w-40" />
                            </div>
                            <p className="text-black text-lg sm:text-xl md:text-2xl font-semibold text-center mt-1">Scan to Pay</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnquiryPdfView